<template>
  <div class="outline-resource">
    <div class="outline-left">
      <div class="outline-menus">
        <div class="left">资源目录</div>
        <div class="right">
          <a-tooltip title="返回大纲目录">
            <svg class="icon-svg menu-item" @click="$emit('change')">
              <use xlink:href="#icon-bar" />
            </svg>
          </a-tooltip>
          <a-tooltip title="关闭">
            <svg class="icon-svg menu-item" @click="$emit('close')">
              <use xlink:href="#icon-close" />
            </svg>
          </a-tooltip>
        </div>
      </div>
      <div class="textbook-title">{{ currentClass?.ClassName }}</div>
      <div class="outline-content">
        <div class="all-outline" v-for="induction in resOutline" :key="induction.id">
          <div class="outline-item title" :key="`${induction.id}-title`" @click.stop="changeExpandState(induction)">
            <span class="expand-btn">
              <svg class="icon-svg caret-icon" :style="{ transform: induction.expand ? 'rotate(0)' : 'rotate(-90deg)' }">
                <use xlink:href="#icon-xiala" />
              </svg>
            </span>
            <span class="title-content">{{induction.title}}</span>
          </div>
          <template v-if="induction.expand">
            <template v-for="type in induction.resources">
              <div class="outline-type" :key="type.key" v-if="type.list.length">
                <div class="outline-type-title" @click.stop="changeExpandStateForChildren(induction, type)">
                  <svg class="icon-svg icon">
                    <use :xlink:href="`#icon-${type.icon}`" />
                  </svg>
                  {{ type.label }}
                </div>
                <div class="resource-list" v-if="type.expand">
                  <div class="outline-item resource" 
                    :class="{ 'active': activeContent && activeContent.id === item.id }"
                    v-for="(item, index) in type.list" 
                    :key="index" 
                    @click="setActiveContent(item, type.key)"
                  >{{ item.title }}</div>
                </div>
              </div>
            </template>
          </template>
        </div>
      </div>
    </div>

    <div class="content">
      <template v-if="activeContent">
        <div class="content-box" ref="contentRef">
          <video v-if="activeContent.type === 'videos'" :src="activeContent.src" controls></video>
          <video v-if="activeContent.type === 'microLessons'" :src="activeContent.src" controls></video>
          <a v-if="activeContent.type === 'attachments'" :href="activeContent.src" target="_blank">点击下载附件：{{ activeContent.title }}</a>
          <audio v-if="activeContent.type === 'audios'" :src="activeContent.src" controls></audio>
          <iframe v-if="activeContent.type === 'iframes'" :src="activeContent.src" frameborder="0"></iframe>
          <img v-if="activeContent.type === 'images'" :src="activeContent.src" alt="">
        </div>

        <div class="title">{{ activeContent.title }}</div>
      </template>
      <div class="tip" v-else>请在左侧目录中选择资源</div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { loadVideoNode } from '../TextbookRender/utils/common'

function guid() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    const r = (Math.random() * 16) | 0
    const v = c === 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}

export default {
  name: 'outline',
  data() {
    return {
      resOutline: [],
      activeContent: null,
    }
  },
  computed: {
    ...mapState({
      currentClass: state => state.currentClass,
      inductions: state => state.intList,
    }),
  },
  mounted() {
    this.initResOutline()
  },
  methods: {
    initResOutline() {
      const resOutline = []
      for(let i = 0; i < this.inductions.length; i++) {
        const item = this.inductions[i]

        const outline = {
          id: item.PK_InductionGuid,
          title: item.InductionName,
          part: item.Part,
          expand: true,
          resources: [
            { key: 'videos', label: '视频', expand: true, icon: 'video', list: [] },
            { key: 'microLessons', label: '微课', expand: true, icon: 'classroom', list: [] },
            { key: 'audios', label: '音频', expand: true, icon: 'audio', list: [] },
            { key: 'iframes', label: '网页', expand: true, icon: 'window', list: [] },
            { key: 'images', label: '图片', expand: true, icon: 'image', list: [] },
            { key: 'attachments', label: '附件', expand: true, icon: 'link', list: [] },
          ],
        }

        const textbookContent = JSON.parse(item.TextbookContent)
        const appConfigs = textbookContent.appConfigs
        const content = textbookContent.content
        
        const fakeDiv = document.createElement('div')
        fakeDiv.innerHTML = content
        const nodes = fakeDiv.querySelectorAll('.image-view, .video-view, .audio-view, .iframe-view, .app-view[data-app-type=mi], .attachment-view')

        for(const node of nodes) {
          let imgAutoIndex = 0

          if(node.classList.contains('image-view')) {
            const img = node.querySelector('img')

            const caption = node.querySelector('.media-caption')
            let title = caption ? caption.dataset.title : '图片'

            if(img.hasAttribute('data-number')) {
              title = `图${i + 1}.${imgAutoIndex + 1} ${title}`
              imgAutoIndex += 1
            }

            outline.resources[4].list.push({
              id: guid(),
              src: img.src,
              title,
            })
          }
          else if(node.classList.contains('video-view')) {
            const video = node.querySelector('video')
            const caption = node.querySelector('.media-caption')
            outline.resources[0].list.push({
              id: guid(),
              src: video.src,
              title: caption ? caption.dataset.title : '视频',
            })
          }
          else if(node.classList.contains('audio-view')) {
            const audio = node.querySelector('audio')
            const caption = node.querySelector('.media-caption')
            outline.resources[2].list.push({
              id: guid(),
              src: audio.src,
              title: caption ? caption.dataset.title : '音频',
            })
          }
          else if(node.classList.contains('iframe-view')) {
            const iframe = node.querySelector('iframe')
            const caption = node.querySelector('.media-caption')
            outline.resources[3].list.push({
              id: guid(),
              src: iframe.src,
              title: caption ? caption.dataset.title : '网页',
            })
          }
          else if(node.classList.contains('app-view')) {
            const nodeId = node.dataset.id
            const config = appConfigs[nodeId]
            const src = config.data.VideoUrl
            outline.resources[1].list.push({
              id: guid(),
              src,
              title: config.title || '微课',
            })
          }
          else if(node.classList.contains('attachment-view')) {
            const src = node.dataset.src
            const title = node.dataset.filename
            outline.resources[5].list.push({
              id: guid(),
              src,
              title: title || '附件',
            })
          }
        }
        if(
          outline.resources[0].list.length ||
          outline.resources[1].list.length ||
          outline.resources[2].list.length ||
          outline.resources[3].list.length ||
          outline.resources[4].list.length ||
          outline.resources[5].list.length
        ) {
          resOutline.push(outline)
        }
      }
      this.resOutline = resOutline
    },
    changeExpandState(induction, state) {
      const resOutline = this.resOutline.map(item => {
        if(item.id === induction.id) {
          return {
            ...item,
            expand: state === undefined ? !item.expand : state,
          }
        }
        return item
      })
      this.resOutline = resOutline
    },
    changeExpandStateForChildren(induction, type, state) {
      const resOutline = this.resOutline.map(item => {
        if(item.id === induction.id) {
          const resources = item.resources.map(resourceItem => {
            if(resourceItem.key === type.key) {
              return {
                ...resourceItem,
                expand: state === undefined ? !resourceItem.expand : state,
              }
            }
            return resourceItem
          })
          return {
            ...item,
            resources,
          }
        }
        return item
      })
      this.resOutline = resOutline
    },
    setActiveContent(item, type) {
      this.activeContent = {
        ...item,
        type,
      }
      if(type === 'videos' || type === 'microLessons') {
        this.$nextTick(() => {
          const video = this.$refs.contentRef.querySelector('video')
          loadVideoNode(video, this.activeContent.src)
        })
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.outline-resource {
  position: fixed;
  inset: 0;
  z-index: 100;
  background-color: #f5f5f5;
}
.content {
  width: calc(100% - 370px);
  position: absolute;
  right: 10px;
  top: 10px;
  bottom: 10px;
  padding: 15px;
  z-index: 11;
  border-radius: 12px;
  box-shadow: 0 0 8px #c1c1c1;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .tip {
    color: #888;
  }

  .content-box {
    width: 80%;
    height: 60%;
    border-radius: 12px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;

    video, iframe {
      width: 100%;
      height: 100%;
    }
    video {
      background-color: #000;
    }
    audio {
      width: 100%;
    }
    img {
      max-width: 100%;
      max-height: 100%;
    }
  }
  .title {
    margin-top: 20px;
    font-size: 13px;
  }
}
.outline-left {
  width: 340px;
  position: absolute;
  left: 10px;
  top: 10px;
  bottom: 10px;
  padding: 15px 15px 5px 12px;
  z-index: 11;
  border-radius: 12px;
  box-shadow: 0 0 8px #c1c1c1;
  background-color: #fff;
  display: flex;
  flex-direction: column;
  user-select: none;

  .outline-content {
    flex: 1;
    overflow: auto;
    padding-right: 12px;
    margin-right: -12px;
  }
  .outline-menus {
    font-size: 18px;
    color: #666;
    flex-shrink: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .left {
      font-weight: 700;
      font-size: 18px;
      color: #333;
    }
    .right {
      .menu-item {
        margin-left: 15px;
      }
    }
    .menu-item {
      cursor: pointer;

      &.active,
      &:hover {
        color: #e86b99;
        transition: color .25s;
      }
    }
  }
  .textbook-title {
    margin: 15px 0;
    flex-shrink: 0;
    font-size: 18px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  .expand-btn {
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
  }
  .outline-type {
    margin-left: 16px;
    font-size: 14px;
    padding: 8px 0;
  }
  .outline-type-title {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-weight: 700;

    .icon {
      margin-right: 4px;
      font-size: 16px;
    }
    .caret-icon {
      margin-right: 2px;
      font-size: 12px;
    }
  }
  .resource-list {
    margin-top: 8px;
  }
  .outline-item {
    padding: 8px 0;
    font-weight: 400;
    font-size: 14px;
    user-select: none;
    cursor: pointer;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;

    &:hover {
      color: #e86b99;
      transition: color .25s;
    }

    &.title {
      font-size: 15px;
      font-weight: 700;
      display: flex;
      align-items: center;

      .expand-btn {
        width: 18px;
        margin-left: -2px;
        flex-shrink: 0;
      }
      .title-content {
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
    }
    &.resource {
      margin-left: 20px;

      &.active {
        color: #e86b99;
      }

      &::before {
        content: '•';
        margin-right: 6px;
      }
    }
  }
}
</style>